import GenericResources from '~/genericResources'

const genericRoutes = []
const castRouteParams = (route) => {
  return {
    id: String(route.params.id),
  }
}

/**
 * Autogenerate routes based genericResources.js
 */
GenericResources.map((resource) => {
  genericRoutes.push({
    path: resource.path,
    component: () =>
      import(/* webpackChunkName: "PageGenericIndex" */ '~pages/Generic/Index'),
    name: resource.name,
    props: {
      resource: resource,
    },
    children: [
      {
        path: ':id/show',
        name: `${resource.name}.show`,
        components: {
          sidebar: () =>
            import(
              /* webpackChunkName: "PageGenericModalShow" */ '~pages/Generic/ModalShow'
            ),
        },
        props: { sidebar: (route) => ({ resource: resource, id: route.params.id }) },
      },
      {
        path: ':id/edit',
        name: `${resource.name}.edit`,
        components: {
          sidebar: () =>
            import(
              /* webpackChunkName: "PageGenericModalShow" */ '~pages/Generic/ModalShow'
            ),
        },
        props: { sidebar: (route) => ({ resource: resource, id: route.params.id }) },
      },
      {
        path: 'new',
        name: `${resource.name}.create`,
        components: {
          sidebar: () =>
            import(
              /* webpackChunkName: "PageGenericModalCreate" */ '~pages/Generic/ModalCreate'
            ),
        },
        props: { sidebar: () => ({ resource: resource }) },
      },
    ],
  })
})

export default [
  {
    path: '/',
    redirect: { name: 'dashboard' },
    name: 'home',
  },
  {
    path: '/my-work',
    component: () =>
      import(/* webpackChunkName: "PageDashboardIndex" */ '~pages/Dashboard/Index'),
    name: 'dashboard',
  },
  {
    path: '/procedure',
    component: () =>
      import(
        /* webpackChunkName: "PageProceduresIndex" */ '~pages/Procedures/Index'
      ),
    name: 'procedures',
  },
  {
    path: '/procedure/:id',
    component: () =>
      import(/* webpackChunkName: "PageProceduresShow" */ '~pages/Procedures/Show'),
    name: 'procedure',
    props: castRouteParams,
  },
  {
    path: '/procedure/:id/edit',
    component: () =>
      import(/* webpackChunkName: "PageProceduresEdit" */ '~pages/Procedures/Edit'),
    name: 'procedure-edit',
    props: castRouteParams,
  },
  {
    path: '/new',
    component: () =>
      import(
        /* webpackChunkName: "PageProceduresCreate" */ '~pages/Procedures/Create'
      ),
    name: 'procedure-create',
  },
  {
    path: '/record',
    component: () =>
      import(/* webpackChunkName: "PageProcessesIndex" */ '~pages/Process/Index'),
    name: 'records',
  },
  {
    path: '/record/new',
    component: () =>
      import(/* webpackChunkName: "PageProceduresShow" */ '~pages/Process/Create'),
    name: 'records.create',
    props: castRouteParams,
  },
  {
    path: '/record/:id',
    component: () =>
      import(/* webpackChunkName: "PageProceduresShow" */ '~pages/Process/Show'),
    name: 'records.show',
    props: castRouteParams,
  },
  {
    path: '/record/:id/edit',
    component: () =>
      import(/* webpackChunkName: "PageProceduresShow" */ '~pages/Process/Edit'),
    name: 'records.edit',
    props: castRouteParams,
  },
  {
    path: '/settings/organization',
    component: () =>
      import(
        /* webpackChunkName: "PageSettingsOrganizationIndex" */ '~pages/SettingsOrganization/Index'
      ),
    name: 'settings.organization',
    meta: { managerRole: true },
  },
  {
    path: '/settings/user',
    component: () =>
      import(
        /* webpackChunkName: "PageSettingsUserIndex" */ '~pages/SettingsUser/Index'
      ),
    name: 'settings.user',
  },
  {
    path: '/settings/users',
    component: () =>
      import(/* webpackChunkName: "PageUsersIndex" */ '~pages/Users/Index'),
    name: 'settings.users',
    meta: { managerRole: true },
  },
  {
    path: '/common',
    component: () =>
      import(/* webpackChunkName: "PageCommonIndex" */ '~pages/Common/Index'),
    name: 'common',
  },
  {
    path: '/companies',
    component: () =>
      import(/* webpackChunkName: "PageCompanyIndex" */ '~pages/Company/Index'),
    name: 'company',
    children: [
      {
        path: 'new',
        name: 'company.create',
        component: () =>
          import(
            /* webpackChunkName: "PageCompanyCreate" */ '~pages/Company/Create'
          ),
      },
    ],
  },
  {
    path: '/companies/:id/show',
    name: 'company.show',
    component: () =>
      import(/* webpackChunkName: "PageCompanyShow" */ '~pages/Company/Show'),
    props: (route) => ({ id: route.params.id }),
    children: [
      {
        path: 'edit',
        name: 'company.edit',
        component: () =>
          import(/* webpackChunkName: "PageCompanyShow" */ '~pages/Company/Edit'),
        props: (route) => ({ id: route.params.id }),
      },
    ],
  },
  {
    path: '/tom',
    component: () =>
      import(/* webpackChunkName: "PageTomIndex" */ '~pages/Tom/Index'),
    name: 'tom',
    children: [
      {
        path: ':id/edit',
        name: 'tom.edit',
        component: () =>
          import(/* webpackChunkName: "PageTomEdit" */ '~pages/Tom/Edit'),
        props: (route) => ({ id: route.params.id }),
      },
      {
        path: 'new',
        name: 'tom.create',
        component: () =>
          import(/* webpackChunkName: "PageTomCreate" */ '~pages/Tom/Create'),
      },
      {
        path: 'templates',
        name: 'tom.templates',
        component: () =>
          import(/* webpackChunkName: "PageTomTemplates" */ '~pages/Tom/Templates'),
      },
    ],
  },
  {
    path: '/tasks',
    component: () =>
      import(/* webpackChunkName: "PageCompanyIndex" */ '~pages/Task/Index'),
    name: 'task',
    children: [
      {
        path: ':id/show',
        name: 'task.show',
        component: () =>
          import(
            /* webpackChunkName: "PageCompanyModalShow" */ '~pages/Task/ModalShow'
          ),
        props: (route) => ({ id: route.params.id }),
      },
      {
        path: 'new',
        name: 'task.create',
        components: {
          sidebar: () =>
            import(
              /* webpackChunkName: "PageTaskModalCreate" */ '~pages/Task/Create'
            ),
        },
      },
    ],
  },
  {
    path: '/recurring-tasks',
    component: () =>
      import(
        /* webpackChunkName: "PageRecurringTaskIndex" */ '~pages/RecurringTask/Index'
      ),
    name: 'recurring-task',
    children: [
      {
        path: ':id/show',
        name: 'recurring-task.show',
        components: {
          sidebar: () =>
            import(
              /* webpackChunkName: "PageRecurringTaskShow" */ '~pages/RecurringTask/Show'
            ),
        },
        props: { sidebar: (route) => ({ id: route.params.id }) },
      },
      {
        path: 'new',
        name: 'recurring-task.create',
        components: {
          sidebar: () =>
            import(
              /* webpackChunkName: "PageRecurringTaskCreate" */ '~pages/RecurringTask/Create'
            ),
        },
      },
    ],
  },
  {
    path: '/documents',
    component: () =>
      import(/* webpackChunkName: "PageDocumentsIndex" */ '~pages/Documents/Index'),
    name: 'documents',
    children: [
      {
        path: ':id/show',
        name: 'document.show',
        component: () =>
          import(
            /* webpackChunkName: "PageDocumentsModalShow" */ '~pages/Documents/ModalShow'
          ),
        props: (route) => ({ id: route.params.id }),
      },
    ],
  },
  {
    path: '/export',
    component: () =>
      import(/* webpackChunkName: "PageExportIndex" */ '~pages/Export/Index'),
    name: 'export',
  },
  {
    path: '/laws/dsgvo',
    component: () =>
      import(/* webpackChunkName: "PageLawDsgvo" */ '~pages/Laws/dsgvo'),
    name: 'law.dsgvo',
    // children: [
    //   {
    //     path: 'dsgvo',
    //     name: 'law.dsgvo',
    //     component: () =>
    //       import(/* webpackChunkName: "PageLawDsgvo" */ '~pages/Laws/dsgvo'),
    //   },
    //   {
    //     path: ':id',
    //     name: 'law.sub',
    //     component: () =>
    //       import(/* webpackChunkName: "PageLawSub" */ '~pages/Laws/LawSub'),
    //     props: true,
    //   },
    // ],
  },
  {
    path: '/laws/:lawName',
    component: () =>
      import(/* webpackChunkName: "PageLawSub" */ '~pages/Laws/LawSub'),
    name: 'law.sub',
    props: true,
  },
  {
    path: '/todo',
    component: () =>
      import(/* webpackChunkName: "PageExportIndex" */ '~pages/Export/Index'),
    name: 'todo',
  },
  {
    path: '/templateselect',
    component: () =>
      import(
        /* webpackChunkName: "PageTemplateTestIndex" */ '~pages/Templates/index'
      ),
    name: 'templateselect',
  },
  {
    path: '/access-request',
    component: () =>
      import(
        /* webpackChunkName: "PageAccessRequestIndex" */ '~pages/AccessRequest/Index'
      ),
    name: 'access-request',
  },
  {
    path: '/access-request/create',
    name: 'access-request.create',
    component: () =>
      import(
        /* webpackChunkName: "PageAccessRequestCreate" */ '~pages/AccessRequest/Create'
      ),
  },
  {
    path: '/access-request/:id/edit',
    name: 'access-request.edit',
    component: () =>
      import(
        /* webpackChunkName: "PageAccessRequestEdit" */ '~pages/AccessRequest/Edit'
      ),
    props: (route) => ({ id: route.params.id }),
  },
  {
    path: '/access-request/:id/show',
    name: 'access-request.show',
    component: () =>
      import(
        /* webpackChunkName: "PageAccessRequestShow" */ '~pages/AccessRequest/Show'
      ),
    props: (route) => ({ id: route.params.id }),
  },
  {
    path: '/breach',
    component: () =>
      import(/* webpackChunkName: "PageBreachIndex" */ '~pages/Breach/Index'),
    name: 'breach',
  },
  {
    path: '/breach/create',
    name: 'breach.create',
    component: () =>
      import(/* webpackChunkName: "PageBreachCreate" */ '~pages/Breach/Create'),
  },
  {
    path: '/breach/:id/edit',
    name: 'breach.edit',
    component: () =>
      import(/* webpackChunkName: "PageBreachEdit" */ '~pages/Breach/Edit'),
    props: (route) => ({ id: route.params.id }),
  },
  {
    path: '/breach/:id/show',
    name: 'breach.show',
    component: () =>
      import(/* webpackChunkName: "PageBreachShow" */ '~pages/Breach/Show'),
    props: (route) => ({ id: route.params.id }),
  },
  ...genericRoutes,
]
